/*******************************************************************************

  Project: NEOKAMIEN
  Author:  KLINIKAREKLAMY
  Date:    11.2020

********************************************************************************

  1. Scroll to top
  2. Off canvas menu
  3. EU Cookie
  4. Dropdown Menu
  5. Lightbox for images and videos
  6. Responsive Videos
  7. Scoll Animations Init
  8. Object Fit Images
  9. Contact Form 7 Fix
  10. Accordion
  11. Map
  12. Equal Heights
  13. Footer fix
  14. Parallax
  15. Header

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Scroll to top
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.c-scroll-to-top').addClass('show');
    } else {
      $('.c-scroll-to-top').removeClass('show');
    }
  });

  $('.c-scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

/* 2. Off canvas menu
------------------------------------------------------------------------------*/

  var $main_nav = $('#mobile-nav');
  var $menu_mode = $main_nav.data('nav-mode');
  var $toggle = $('.js-menu-toggle');

  var defaultData = {
    maxWidth: false,
    pushContent: $('.l-outline'),
    position: 'right',
    customToggle: $toggle,
    navTitle: false,
    levelTitles: true,
    insertClose: false,
    closeLevels: true,
    disableBody: true,
    removeOriginalNav: true,
    levelSpacing: 20,
    // labelBack: 'Zurück'
    // labelClose: 'Zamknij',
    // insertBack: 'Cofnij'
  };

  if($menu_mode != 'disabled') {
    var Nav = $main_nav.hcOffcanvasNav(defaultData);

    Nav.on('open', function(event, settings) {
      $('.c-header').addClass('c-header--scrolled');
    });
  }

  $toggle.on('click', function(e){
    e.preventDefault();
    $toggle.toggleClass('is-active');
    $('.c-header').addClass('c-header--scrolled');
  });

  function setMobMenuPadding() {
    $headerHeight = $('.c-header').outerHeight();
    $('.nav-wrapper').css('padding-top', $headerHeight + 'px');
  }
  setMobMenuPadding();
  $(window).on("debouncedresize", function( event ) {
    setMobMenuPadding();
  });

  // Hide navigation when user pressed Escape key on keyboard
  $(document).on('keyup', function(e){
    if (e.keyCode === 27) {
      Nav.close();
    }
  });

/* 3. EU Cookie
------------------------------------------------------------------------------*/

  // Variables
  var expires_date = new Date('December 31, 2099 23:59:59');
  var cookie_notice_height = $('.cookie-bar').height();

  // Update variables and padding after screen resize
  $(window).on("debouncedresize", function( event ) {
    cookie_notice_height = $('.cookie-bar').height();
    if(!(Cookies.get('eu-cookie-law-neokamien') == 'accepted' || Cookies.get('eu-cookie-law-neokamien') == 'refused')) {
      $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    }
  });

  // Show cookie notice if it's not configured
  if(Cookies.get('eu-cookie-law-neokamien') == 'accepted' || Cookies.get('eu-cookie-law-neokamien') == 'refused') {
    $('body').removeClass('cookie-bar--not-decided');
  }
  else {
    $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    $('body').addClass('cookie-bar--not-decided');
  }

  // Hide cookie if it's accepted
  $('.js-accept-cookie').on('click', function(e){
    e.preventDefault();
    Cookies.set('eu-cookie-law-neokamien', 'accepted', { expires: expires_date });
    $('body').removeClass('cookie-bar--not-decided');
  });

  // Disable scripts and hide notice
  $('.js-refuse-cookie').on('click', function(e){
    e.preventDefault();
    if(theme_settings.cookie_popup == 1) {
      $.magnificPopup.open({
        items: {
            src: '<div class="white-popup">' + theme_settings.cookie_popup_text + '</div>',
            type: 'inline'
        },
        mainClass: 'mfp-with-fade',
        removalDelay: 160
      });
    }
    else {
      console.log('Tracking scripts and cookies are disabled.');
    }
    Cookies.set('eu-cookie-law-neokamien', 'refused', { expires: expires_date });
    // Opt out functions
    // doOptout();
    $('body').removeClass('cookie-bar--not-decided');
  });

/* 4. Dropdown Menu
------------------------------------------------------------------------------*/

  $('.c-hor-menu .menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });
  $('.c-hor-menu .menu-item-has-children > a > .sub-menu').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('opened');
  });

  // Hide dropdown after click outside the menu
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.c-hor-menu .menu-item-has-children a').length) {
      $('.c-hor-menu .menu-item-has-children').removeClass('opened');
    }
  });

/* 5. Lightbox for images and videos
------------------------------------------------------------------------------*/

  $('a[href$=jpg], a[href$=jpeg], a[href$=jpe], a[href$=png], a[href$=gif]').magnificPopup({
    type: 'image',
    removalDelay: 500,
    mainClass: 'mfp-with-fade',
    closeOnContentClick: true,
    midClick: true,
    gallery: {
			enabled: true,
      navigateByImgClick: true,
      tCounter: '%curr% z %total%',
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
  });

  $('.popup').magnificPopup({
    type: 'image',
    removalDelay: 500,
    mainClass: 'mfp-with-fade',
    closeOnContentClick: true,
    midClick: true,
  });

  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-with-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
			patterns: {
        youtube: {
          index: 'youtube.com/',
          id: function(url) {
                  var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                  if ( !m || !m[1] ) return null;
                  return m[1];
              },
          src: '//www.youtube.com/embed/%id%?autoplay=1'
        },
				youtube_short: {
				  index: 'youtu.be/',
				  id: 'youtu.be/',
				  src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
				}
			}
		}
  });

/* 6. Responsive Videos
/*******************************************************************************/

  fitvids({
    // players: 'iframe[src*="example.com"]'
  });

/* 7. Scoll Animations Init
/*******************************************************************************/

  AOS.init({
    disable: 'mobile',
    once: true
  });

  window.addEventListener('load', AOS.refresh);

  function refreshAOS() {
    AOS.refresh();
  }

  $('img').on('load', _.throttle(refreshAOS, 1000));

/* 8. Object Fit Images
/*******************************************************************************/

  objectFitImages();

/* 9. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

/* 10. Accordion
/*******************************************************************************/

  // Hide all accordions
  var allPanels = $('.accordion dd').hide();
  var allTitles = $('.accordion dt');

  $('.accordion dt > a').click(function(e) {
  e.preventDefault();
  $this = $(this);
  $title = $this.parent();
  $target =  $this.parent().next();

  if(!$target.hasClass('accordion__text--active')){
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
    $target.addClass('accordion__text--active').slideDown();
    $title.addClass('accordion__subtitle--active');
  }
  else {
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
  }
  return false;
  });

/* 11. Map
/*******************************************************************************/

  $.each($('.dyn-map'), function(){

    var lat = $(this).data('lat');
    var long = $(this).data('long');
    var zoom = $(this).data('zoom');

    L.Icon.Default.imagePath = theme_settings.template_dir + '/assets/img/leaflet/';
    var mymap = new L.map($(this)[0], {
    scrollWheelZoom: false
    }).setView([lat, long], 16);

    // create custom icon
    var pinIcon = L.icon({
        iconUrl: theme_settings.template_dir + '/assets/img/leaflet/pin.svg',
        shadowUrl:  theme_settings.template_dir + '/assets/img/leaflet/marker-shadow.png',
        iconSize: [40, 50], // size of the icon
        iconAnchor:   [16, 50],
        shadowAnchor: [10, 39],
        popupAnchor:  [5, -48]
    });

    // Open Street Map - Wikimedia
    L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
        attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
        maxZoom: zoom
    }).addTo(mymap);

    if($(this).data('popup')) {
      L.marker([lat, long], {icon: pinIcon}).addTo(mymap)
      .bindPopup($(this).data('popup'))
      .openPopup();
    }

    // Open Street Map
    /*
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Open Street Map - Black and White
    /*
    L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Mapbox - remember to change accessToken
    /*
    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: zoom,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoiYWRhbXBpbGNoIiwiYSI6ImNqbTY0aGlzeTB0eTEza280dGVpcjVnemMifQ.zZjr5GSWWpe4lYGBjvuz1A'
    }).addTo(mymap);
    */

    mymap.on('click', function() {
    if (mymap.scrollWheelZoom.enabled()) {
      mymap.scrollWheelZoom.disable();
      }
      else {
      mymap.scrollWheelZoom.enable();
      }
    });

  });

/* 12. Equal Heights
------------------------------------------------------------------------------*/

  // Example:
  // $('.something').matchHeight();

  // Match Height compatibility with Lazy Load techniques
  function refreshMatchHeight() {
    $.fn.matchHeight._update();
  }
  $('img').on('load', _.throttle(refreshMatchHeight, 1000));

/* 13. Footer fix
------------------------------------------------------------------------------*/

  function fixFooter() {
    if($('body').outerHeight() < $(window).outerHeight()) {
      var footerHeight = $('.js-footer').outerHeight();
      var bodyHeight = $('body').outerHeight();
      var windowHeight = $(window).outerHeight();
      var contentHeight = bodyHeight - footerHeight;
      $('.js-footer').css('min-height', windowHeight - contentHeight + 'px');
    }
  }

  fixFooter();
  $(window).on("debouncedresize", function( event ) { fixFooter(); });

/* 14. Parallax
------------------------------------------------------------------------------*/

  window.onload = function() {
    lax.setup(); // init

    function updateLax(){
      lax.update(window.scrollY);
      window.requestAnimationFrame(updateLax);
    }

    window.requestAnimationFrame(updateLax);
  };

/* 15. Header
------------------------------------------------------------------------------*/

    // Function which controls header status according to the distance from top
    function setHeaderStatus(scroll){
      if (scroll >= 1) { $('.c-header').addClass('c-header--scrolled'); }
      else {
        if(!($('body').hasClass('hc-nav-open'))) {
          $('.c-header').removeClass('c-header--scrolled');
        }
      }
    }

    // Set status on load
    setHeaderStatus($(window).scrollTop());

    // Set status during the scroll
    $(window).scroll(function() {
      setHeaderStatus($(window).scrollTop());
    });


/* 16. Tabs
------------------------------------------------------------------------------*/


$('.tabs li:first').addClass('active');
$('.tab__content li:first').addClass('active');

	// Variables
	var clickedTab = $(".tabs > .active");
	var tabWrapper = $(".tab__content");
	var activeTab = tabWrapper.find(".active");
	// var activeTabHeight = activeTab.outerHeight();

	// Show tab on page load
	activeTab.show();

	// Set height of wrapper on page load
	// tabWrapper.height(activeTabHeight)

	$(".tabs > li").on("click", function() {

		// Remove class from active tab
		$(".tabs > li").removeClass("active");

		// Add class active to clicked tab
		$(this).addClass("active");

		// Update clickedTab variable
		clickedTab = $(".tabs .active");

		// fade out active tab
		activeTab.fadeOut(100, function() {

			// Remove active class all tabs
			$(".tab__content > li").removeClass("active");

			// Get index of clicked tab
			var clickedTabIndex = clickedTab.index();

			// Add class active to corresponding tab
			$(".tab__content > li").eq(clickedTabIndex).addClass("active");

			// update new active tab
			activeTab = $(".tab__content > .active");

			// Update variable
			activeTabHeight = activeTab.outerHeight();

			// Animate height of wrapper to new tab height
			tabWrapper.stop().delay(50).animate({
				height: activeTabHeight
			}, 100, function() {

				// Fade in active tab
				activeTab.delay(50).fadeIn(100);

			});
		});
	});


/* 17. Buildings Hover Effect
------------------------------------------------------------------------------*/

$('.buildings-btn1').hover(
       function(){ $('.buildings__el1').addClass('hovered'); },
       function(){ $('.buildings__el1').removeClass('hovered'); }
);

$('.buildings-btn2').hover(
       function(){ $('.buildings__el2').addClass('hovered'); },
       function(){ $('.buildings__el2').removeClass('hovered'); }
);

/* 18. Showcase
------------------------------------------------------------------------------*/

$('.showcase__wrapper').slick({
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  adaptiveHeight: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 7000,
  responsive: [
    {
      breakpoint: 1255,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
      }
    },
  ]
});

/* 19. Slider
------------------------------------------------------------------------------*/

$('.slider__wrapper').slick({
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  centerMode: true,
  centerPadding: '60px',
  adaptiveHeight: true,
  arrows: false,
  dots: true,
  responsive: [
    {
      breakpoint: 540,
      settings: {

        slidesToShow: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {

        slidesToShow: 2,
      }
    },
  ]
});


}); // end of jQuery code
